import { NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { ZopHorizontalNavigationComponent } from '../../horizontal.component';
import { ZopNavigationService } from '../../../navigation.service';
import { ZopNavigationItem } from '../../../navigation.types';

@Component({
    selector: 'zop-horizontal-navigation-divider-item',
    templateUrl: './divider.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgClass]
})
export class ZopHorizontalNavigationDividerItemComponent
  implements OnInit, OnDestroy
{
  @Input() item: ZopNavigationItem;
  @Input() name: string;

  private _zopHorizontalNavigationComponent: ZopHorizontalNavigationComponent;
  private _unsubscribeAll: Subject<any> = new Subject<any>();

  /**
   * Constructor
   */
  constructor(
    private _changeDetectorRef: ChangeDetectorRef,
    private _zopNavigationService: ZopNavigationService
  ) {}

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    // Get the parent navigation component
    this._zopHorizontalNavigationComponent =
      this._zopNavigationService.getComponent(this.name);

    // Subscribe to onRefreshed on the navigation component
    this._zopHorizontalNavigationComponent.onRefreshed
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(() => {
        // Mark for check
        this._changeDetectorRef.markForCheck();
      });
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }
}
